import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      class: "p-button-danger p-button-outlined p-mt-3 p-col-8",
      label: _ctx.$t('activity.quit.button'),
      loading: _ctx.removeLoading,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.preventDelete(false)))
    }, null, 8, ["label", "loading"]),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('activity.quit.attention'),
      visible: _ctx.dialog.show,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog.show) = $event)),
      breakpoints: { '960px': '80vw' },
      style: { width: '30vw' },
      modal: true,
      "content-class": "p-d-flex p-ai-center"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('cancel'),
          icon: "pi pi-times",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialog.show = false)),
          class: "p-button-text",
          autofocus: ""
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          icon: "pi pi pi-exclamation-triangle",
          label: _ctx.counter !== 0 ? _ctx.counter + '' : _ctx.$t('confirm'),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmLeaving(_ctx.id))),
          class: "p-button-raised p-button-danger",
          disabled: !_ctx.dialog.checked || _ctx.counter !== 0,
          "icon-pos": "right"
        }, null, 8, ["label", "disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.dialog.checked,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog.checked) = $event)),
          binary: true
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("activity.quit.warning")), 1)
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
}